import React, { useEffect, useState } from 'react';
import { TAG_TYPES, showError, showSuccess } from 'utils';
import { Loading } from 'components/loading/Loading';
import ActionButton from 'components/ActionButton';
import DataTable from 'components/DataTable';
import { tableStyles } from 'css/tableStyles';
import styles from './index.module.scss';
import DeleteActionForTable from 'components/DeleteActionForTableData';
import {  fetchSubscriptionPlanTags,removeTagFromSubscription } from 'services/api/subscriptions';
import AssignTagModal from 'components/AssignTagModal';
import CustomLink from 'components/TableLink';

const SubscriptionPlanTags =(props)=>{
  const { subscriptionId = '' } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [subscriptionTags, setSubscriptionTags] = useState<Record<string, any>[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);

  const columns =[
    {
      name: 'Id',
      selector: 'objectId',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: row => (
        <CustomLink
          text={row.objectId}
          linkTo={`/available-tags/${row.objectId}`}
        />
      ),
    },
    {
      name: 'Name',
      selector: 'value',
    },
    {
      name: 'English Name',
      selector: 'enValue',
    },
    {
      name: 'Slug',
      selector: 'slug',
    },
    {
      name: 'English Slug',
      selector: 'enSlug',
    },
    {
      name: 'Action',
      selector: '',
      // eslint-disable-next-line react/display-name
      cell: (row: Record<string, any>) => (
        <div className={'ml-3'}>
          <DeleteActionForTable
            onClick={() => deletAvailableTags(row.objectId)}
          />
        </div>
      ),
    },
  ];

  const deletAvailableTags = async(tagId)=>{
    try{
      await removeTagFromSubscription(subscriptionId, tagId);
      showSuccess('Tag is removed Successfully');
      fetchItemTags();
    }catch(e){
      showError(e);
    }
  };

  const fetchItemTags = async () => {
    setLoading(true);
    try {
      const response = await fetchSubscriptionPlanTags(subscriptionId);
      setSubscriptionTags(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItemTags();
  }, []);

  return (
    <>
      {loading ? <Loading /> : null}
      {openModal && 
        <AssignTagModal
          toggleModal={()=>setOpenModal(!openModal)} 
          onSuccess={()=>fetchItemTags()}
          itemId={subscriptionId}
          assignedTags={subscriptionTags.map(tag=>tag.objectId)}
          tagType={TAG_TYPES.SUBSCRIPTION}
        />
      }
      <div className={styles['related-items-container']}>
        <div className={styles['section-header']}>
          <div className={styles['section-heading']}>Assigned Tags</div>
          <ActionButton
            text={<>Assign Tags <span className={'ml-3'}>+</span></>}
            active={true}
            isLoading={false}
            onClick={() => setOpenModal(true)}
          />
        </div>
        <DataTable
          columns={columns}
          noHeader={true}
          data={subscriptionTags}
          highlightOnHover={true}
          customStyles={tableStyles}
          pagination={false}
        />
      </div>
    </>
  );
};

export default SubscriptionPlanTags;